module.exports = __webpack_public_path__ + "static/img/4.64de4db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/atlas/test/4.jpg
// module id = eKSA
// module chunks = 1